
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[eventId]",
      function () {
        return require("private-next-pages/[eventId]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[eventId]"])
      });
    }
  